import { render, staticRenderFns } from "./navMenu.vue?vue&type=template&id=0a15b9d1&scoped=true&"
import script from "./navMenu.vue?vue&type=script&lang=js&"
export * from "./navMenu.vue?vue&type=script&lang=js&"
import style0 from "./navMenu.vue?vue&type=style&index=0&id=0a15b9d1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a15b9d1",
  null
  
)

export default component.exports